import {Component, Input, ViewChild} from '@angular/core';
import {CmButtonDropdownComponent} from './cm-button-dropdown.component';

@Component({
  selector: 'cm-filters-dropdown',
  template: `
    <cm-button-dropdown #dropdown [header]="header" [tooltip]="'Filters'" [icon]="'filter_list'">
      <ng-content></ng-content>
    </cm-button-dropdown>
  `,
})
export class FiltersDropdownComponent {
  @ViewChild('dropdown', { static: true }) dropdown: CmButtonDropdownComponent;
  @Input() public header: string;

  constructor() {
  }

  hide() {
    this.dropdown.hide();
  }
}
